const mutations = {
  SET_TOASTER (state, data) {
    state.toaster = {
      ...data
    }
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/shared/mutations.js